// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1UGPS","description":"PatientConsentPreview_description__I9ZZs"};